module.exports = "pegasus/assets/themelp1/travel/109.png";